// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iYoY","content":"styles_content__1FQbJ","row":"styles_row__24V48","footer":"styles_footer__2wQO4","phraseLength":"styles_phraseLength__1y9Ai"};